export default __webpack_public_path__ + "static/media/red-flag.7ce30dbd.svg";